// extracted by mini-css-extract-plugin
export default {"container":"S30uDa"};